import { OrgWidgetSettings } from './user';

export enum OrgWidgetPageRuleEventType {
  VISIT = 'VISIT',
  CLICK = 'CLICK',
  FORM = 'FORM',
}

export interface OrgWidgetPageRuleEvent {
  event: OrgWidgetPageRuleEventType;
  selector?: string;
  delay?: number;
  oncePerSession?: boolean;
}

export interface OrgWidgetPageRuleProactiveVideo extends OrgWidgetPageRuleEvent {
  videoId: number;
}

export interface OrgWidgetPageRuleAlert extends OrgWidgetPageRuleEvent {
  title: string;
  message?: string;
}

export interface OrgWidgetPageRule {
  id: number;
  weight: number;
  page: string;
  alerts?: OrgWidgetPageRuleAlert[];
  expand?: OrgWidgetPageRuleEvent | null;
  widgetSettings?: Partial<OrgWidgetSettings>;
  proactiveVideo?: OrgWidgetPageRuleProactiveVideo;
}

export interface NewOrgWidgetPageRule extends Omit<OrgWidgetPageRule, 'id' | 'weight'> {
  first: boolean;
}
